import { render, staticRenderFns } from "./SelectArea.vue?vue&type=template&id=6360568d&scoped=true"
import script from "./SelectArea.vue?vue&type=script&lang=js"
export * from "./SelectArea.vue?vue&type=script&lang=js"
import style0 from "./SelectArea.vue?vue&type=style&index=0&id=6360568d&prod&lang=less"
import style1 from "./SelectArea.vue?vue&type=style&index=1&id=6360568d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6360568d",
  null
  
)

export default component.exports